declare const angular: ng.IAngularStatic;
declare const app;
declare const CloudZoom;
declare const document;
declare const $;

export class productImageGalleryController {
    images;
    selectedImage;
    constructor(private $mdDialog, private $product, private $state) {
        "ngInject"
    }
    $onInit() {
        this.$product.images({ productId: this.$state.params.pID },
            response => {
                response.map((img) => {
                    if (img.IsDefault) {
                        this.selectedImage = img
                    }
                })

                this.images = response;
            }
        )
    }

    lightBox(ev) {
        let images = []
        this.images.map(img => {
            let image = {
                src: img.MediumImageUrl,
                'data-err-src': 'product',
                thumb: img.ThumbImageUrl
            }
            images.push(image)
        })

        $(document).lightGallery({
            dynamic: true,
            mobileSrc: true,
            showThumbByDefault: false,
            download: false,
            dynamicEl: images
        });
        // $(document).on('onAfterOpen.lg', () => {
        //     $('.lg-outer img').map((key, val) => {
        //         $(val).attr('err-src', 'product')
        //     })
        // })
    }
}




// WEBPACK FOOTER //
// ./src/components/product-image-gallery/product-image-gallery.controller.ts